<template>
    <div class="rsv2_time_select" :style="styleString" v-if="isShow">
        <div class="guide">{{ $t('reservationwindow.reservationmonitor.label_move_title') }}</div>
        <div class="info">
            <div class="user_info ellipsis">
                <div class="name ellipsis">{{ name }}</div>
                <div class="chartnum ellipsis" v-if="usingChartNumber">{{ chartNumber }}</div>
            </div>
        </div>
        <div class="info" v-if="!isEmptyReservation">
            <b>{{ $t('reservationwindow.reservationmonitor.label_program') }} :</b>
            <span class="ellipsis">{{ programName }}</span>
        </div>
        <div class="info memo" v-if="!isEmptyReservation">
            <b>{{ $t('reservationwindow.reservationmonitor.label_memo') }} :</b>
            <pre>{{ note }}</pre>
        </div>
    </div>
</template>


<script>
import { clearSaaSTimeSelectMode, exitTimeSelectMode, reservationSelection } from '../../../reservation-selection'

export default {
    props: {
        position: Object
    },
    data() {
        return {
            reservationSelection,
        }
    },
    computed: {
        isShow: function () {
            return this.reservationSelection.isTimeSelectMode && this.isHidden == false
        },
        isHidden: function () {
            return !this.reservationSelection.isShowTimeSelectInfo
        },
        x: function () {
            return this.position?.x ?? 0
        },
        y: function () {
            return this.position?.y ?? 0
        },
        styleString: function () {
            return 'top: ' + this.y + 'px; ' + 'left: ' + this.x + 'px;'
        },
        reservation: function () {
            console.log(this.reservationSelection.selectedReservation)
            return this.reservationSelection.selectedReservation
        },
        isEmptyReservation: function () {
            return !this.reservation?.programID?._id
        },
        hservice: function () {
            return this.reservationSelection.selectedHService
        },
        name: function () {
            return this.hservice.name
        },
        chartNumber: function () {
            return '(' + (this.hservice?.chartNumber ?? '') + ')'
        },
        programName: function () {
            return this.reservation?.programID?.title
        },
        note: function () {
            return this.reservation?.note
        },
        usingChartNumber: function () {
            return this.servicesetting?.setting?.usingChartNumber ?? false
        },
    },
    mounted() {
        this.addEventListener()
    },
    beforeDestroy() {
        this.removeEventListener()
    },
    methods: {
        // MARK: - for event listener
        handleKeyUp(e) {
            if (e.keyCode == 27) {
                exitTimeSelectMode()
                clearSaaSTimeSelectMode()
            }
        },
        addEventListener() {
            window.addEventListener('keyup', this.handleKeyUp)
        },
        removeEventListener() {
            window.removeEventListener('keyup', this.handleKeyUp)
        }
    }
}
</script>